import { format } from 'date-fns'

export const checkIsNotIncluded = (date, workingDays) => {
  // `true` disables the calendar days
  if (!Boolean(workingDays?.length)) return true

  const formattedDate = format(new Date(date), 'yyyy-MM-dd')
  return !workingDays.includes(formattedDate)
}
